import { DescriptionAlign } from 'aid-form-service/lib/ApiClient/index.types';
import { CSSProperties } from 'react';

export function parseAlign(align: DescriptionAlign) {
  return align.toLocaleLowerCase() as Required<CSSProperties['textAlign']>;
}
